<template>
<div class="serviceProviderTip">
    <div class="cc-body">
        <img :src="noPower" alt="" class="img">
        <div class="tip">{{tip}}</div>
        <div class="btn" v-if="user.isprovider==0">
            <el-button type="primary" @click="handleAdd">立即开通</el-button>
        </div>
    </div>
    <serviceProviderEditDialog ref="serviceProviderEditDialog"></serviceProviderEditDialog>
</div>
</template>

<script>
import ServiceProviderEditDialog from 'views/serviceProvider/components/serviceProviderEditDialog.vue'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'serviceProviderTip',
    data() {
        return {
            noPower: require('@/common/images/creativeAccount/noPower.png'),
            tip: '您还未开通服务商功能，快去开通吧'
        }
    },
    mounted() {
        if (this.user.isprovider == 1 && this.user.providerstatus == 0) {
            this.tip = '您的服务商申请正在审核，请稍等'
        }
    },
    methods: {
        handleAdd() {
            this.openServiceProviderEditDialog()
        },
        openServiceProviderEditDialog() {
            this.$refs.serviceProviderEditDialog.openDialog('add')
        }
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['user'])
    },
    components: {
        ServiceProviderEditDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.serviceProviderTip {
    .cc-body{
        padding-top: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .item-loading{
            width: 200px;
            margin:0 0 60px 0;
        }
        .img{
            width: 374px;
            height: 275px;
        }
        .tip{
            color: #E6A23C;
            font-size: 16px;
            line-height: 24px;
        }
        .btn{
            margin-top: 60px;
        }
    }
}
</style>
